import { GiCancel } from "react-icons/gi";

const CancelIcon = () => {
  return <GiCancel />;
};

export default CancelIcon;
